<template>
  <header class="header-wrapper header-wrapper-bg">
    <nav class="isPc nav-wrapper container mx-auto flex justify-between items-center">
      <div class="left-wrapper flex items-center">
        <img width="120" class="cursor-pointer" src="../../assets/img/logo002.png" alt="logo" @click="toHome">
        <div class="menu-wrapper">
          <Menu active-name="1" theme="dark">
            <MenuItem name="1">
              <router-link class="menu-item" to="/projects" active-class="active">
                Projects
              </router-link>
            </MenuItem>
            <MenuItem v-if="roles.includes('artist')" name="2">
              <router-link class="menu-item" to="/manage/create" active-class="active">
                Apply
              </router-link>
            </MenuItem>
            <MenuItem v-if="roles.includes('admin')" name="3">
              <router-link class="menu-item" to="/manage/audit" active-class="active">
                Audit
              </router-link>
            </MenuItem>
            <MenuItem v-if="roles.includes('artist')" name="4">
              <router-link class="menu-item" to="/manage/projects" active-class="active">
                List
              </router-link>
            </MenuItem>
            <!-- <MenuItem v-if="ethAddress" name="5">
              <router-link
                class="menu-item"
                :to="`/user/${ethAddress}`"
                active-class="active"
              >
                Purchased Items
              </router-link>
            </MenuItem> -->
            <MenuItem name="6">
              <router-link class="menu-item" to="/members" active-class="active">
                Members
              </router-link>
            </MenuItem>
          </Menu>
        </div>
      </div>
      <div class="right-wrapper">
        <button v-if="!ethAddress" class="connectBtn" @click="openWalletDialog">
          Connect Wallet
        </button>
        <div v-else class="connected-content flex justify-start items-center">
          <div v-if="roles.includes('admin') || roles.includes('artist')" class="sign-wrapper mr-5">
            <button v-if="isSign">
              已签名
            </button>
            <button v-else @click="sign">
              签名
            </button>
          </div>

          <Dropdown trigger="click" @on-click="choseFunc">
            <div class="connected-content flex justify-start items-center">
              <img src="../../assets/img/metamask18.svg" alt="metamask">
              <span>{{ getShortAddress }}</span>
              <img class="arrow" src="../../assets/img/down.svg" alt="down">
            </div>
            <DropdownMenu slot="list" class="func-list-wrapper">
              <DropdownItem class="list-item flex justify-start items-center" name="copy">
                <img src="../../assets/img/copy16.svg" alt="copy">
                <span>{{ $t('header.copyAddress') }}</span>
              </DropdownItem>
              <DropdownItem class="list-item flex justify-start items-center" name="profile">
                <img src="../../assets/img/profile.svg" alt="profile" @click="toProfile">
                <span>Profile</span>
              </DropdownItem>
              <DropdownItem class="list-item flex justify-start items-center" name="purchased">
                <img src="../../assets/img/purchased.svg" alt="Purchased">
                <router-link v-if="ethAddress" class="menu-item" :to="`/user/${ethAddress}`" active-class="active">
                  <span>Purchased Items</span>
                </router-link>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </nav>
    <nav class="isMobile flex items-center justify-between">
      <div class="Mwrapper">
        <img src="../../../public/logo.png" alt="logo" @click="toHome">
        <div>
          <div class="right-wrapper flex items-center justify-between">
            <button v-if="!ethAddress" class="connectBtn" @click="openWalletDialog">
              Connect Wallet
            </button>
            <div v-else class="connected-content flex justify-start items-center">
              <Dropdown trigger="click" @on-click="choseFunc">
                <div class="connected-content flex justify-start items-center">
                  <img src="../../assets/img/metamask18.svg" alt="metamask">
                  <span>{{ getShortAddress }}</span>
                  <img class="arrow" src="../../assets/img/down.svg" alt="down">
                </div>
                <DropdownMenu slot="list" class="func-list-wrapper">
                  <DropdownItem class="list-item flex justify-start items-center" name="copy">
                    <img src="../../assets/img/copy16.svg" alt="copy">
                    <span>{{ $t('header.copyAddress') }}</span>
                  </DropdownItem>
                  <DropdownItem class="list-item flex justify-start items-center" name="profile">
                    <img src="../../assets/img/profile.svg" alt="profile" @click="toProfile">
                    <span>Profile</span>
                  </DropdownItem>
                  <DropdownItem class="list-item flex justify-start items-center" name="purchased">
                    <img src="../../assets/img/purchased.svg" alt="Purchased">
                    <router-link v-if="ethAddress" class="menu-item" :to="`/user/${ethAddress}`" active-class="active">
                      <span>Purchased Items</span>
                    </router-link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <img src="../../assets/img/menu.svg" alt="menu" class="menu" @click="openMenu = true">
            <!-- <Button type="primary" @click="openMenu = true">
          Open
        </Button> -->
            <Drawer v-model="openMenu" :closable="false">
              <Menu active-name="1" theme="dark">
                <MenuItem name="1">
                  <router-link class="menu-item" to="/projects" active-class="active">
                    Projects
                  </router-link>
                </MenuItem>
                <MenuItem v-if="roles.includes('artist')" name="2">
                  <router-link class="menu-item" to="/manage/create" active-class="active">
                    Apply
                  </router-link>
                </MenuItem>
                <MenuItem v-if="roles.includes('admin')" name="3">
                  <router-link class="menu-item" to="/manage/audit" active-class="active">
                    Audit
                  </router-link>
                </MenuItem>
                <MenuItem v-if="roles.includes('artist')" name="4">
                  <router-link class="menu-item" to="/manage/projects" active-class="active">
                    List
                  </router-link>
                </MenuItem>
                <!-- <MenuItem v-if="ethAddress" name="4">
                  <router-link
                    class="menu-item"
                    :to="`/user/${ethAddress}`"
                    active-class="active"
                  >
                    Purchased Items
                  </router-link>
                </MenuItem> -->
                <MenuItem name="6">
                  <router-link class="menu-item" to="/members" active-class="active">
                    Members
                  </router-link>
                </MenuItem>
              </Menu>
            </Drawer>
          </div>
        </div>
      </div>
    </nav>
    <walletdialog ref="wallet" />
  </header>
</template>

<script>
import { mapState } from 'vuex';
import { fetchPost } from '@/common/utils/request.js';
import jscookie from 'js-cookie';
export default {
  data() {
    return {
      openMenu: false,
    };
  },
  components: {
    walletdialog: () => import('./dialog/walletDialog'),
  },
  methods: {
    openWalletDialog() {
      this.$refs.wallet.open();
    },
    toHome() {
      this.$router.push(`/`);
    },
    copyAddress() {
      this.$copyText(this.ethAddress).then(() => {
        this.$Notice.success({
          title: this.$t('notice.n36'),
        });
      });
    },
    async choseFunc(val) {
      if (val === 'copy') {
        this.copyAddress();
      }
      if (val === 'profile') {
        this.toProfile();
      }
    },
    toProfile() {
      this.$router.push(`/profile/${this.ethAddress}`);
    },
    sign() {
      try {
        const from = this.ethAddress;
        console.log(from);
        const val = from.toString();
        const msg = this.web3.utils.toHex(val);
        const params = [msg, from];

        const method = 'personal_sign';
        // const _this = this;
        this.web3.currentProvider.sendAsync({ method, params, from }, async (err, result) => {
          if (err) return console.error(err);
          if (result.error) return console.error(result.error);

          console.log('PERSONAL SIGNED:' + JSON.stringify(result.result));
          const param = {
            address: this.ethAddress,
            sign: result.result,
          };
          const res = await fetchPost('/api/get_cookie', param);
          if (res.status === 200) {
            this.$store.commit('setIsSign', true);
          }

          // const signature = result.result;
        });
      } catch (error) {
        console.log(error);
      }
    },
    checkSign() {
      const signVal = jscookie.get('nft_art_cookie');
      // console.log(signVal);
      if (!signVal) {
        this.$store.commit('setIsSign', false);
        this.$Notice.warning({
          title: 'Please sign again',
          duration: 15,
        });
      } else {
        this.$store.commit('setIsSign', true);
      }
    },
  },
  computed: {
    ...mapState(['web3', 'ethAddress', 'ethChainID', 'roles', 'isSign']),
    getShortAddress() {
      return `${this.ethAddress.slice(0, 6)}...${this.ethAddress.slice(-6)}`;
    },
  },
  created() {
    this.checkSign();
  },
};
</script>

<style lang="less" scoped>
.header-wrapper {
  width: 100%;
  height: 88px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: #323c41;
  .nav-wrapper {
    height: 100%;
    .left-wrapper {
      width: 150px;
      // height: 100%;
      .menu-wrapper {
        white-space: nowrap;
        margin-left: 80px;
        .menu-item {
          display: inline-block;
          text-align: center;
          padding: 0px 16px;
          height: 28px;
          margin-right: 10px;
          font-size: 16px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
        }
        .active {
          display: inline-block;
          height: 28px;
          text-align: center;
          // background: #0058ff;
          // border-radius: 14px;
          font-size: 16px;
          font-weight: 500;
          color: #bbb;
          line-height: 28px;
        }
      }
    }
    .right-wrapper {
      .connectBtn {
        width: 148px;
        height: 40px;
        border-radius: 20px;
        line-height: 19px;
        font-size: 16px;
        color: #fff;
        border: 1px solid #fafafa;
        outline: none;
      }
      .connected-content {
        img {
          max-width: 14px;
          margin-right: 8px;
        }
        span {
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          color: #fff;
          line-height: 14px;
        }
        .arrow {
          margin-left: 8px;
        }
        .list-item {
          height: 40px;
          align-items: center;
          box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.06);
          img {
            max-width: 16px;
            margin-right: 8px;
          }
          span {
            font-size: 14px;
            font-weight: 500;
            color: #14171c;
            line-height: 16px;
          }
        }
      }
    }
  }
}
.header-wrapper-bg {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
}
@media (max-width: 1025px) {
  .isMobile {
    .Mwrapper {
      padding: 0 10px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        max-width: 100px;
      }
      .menu {
        max-width: 24px;
        margin-left: 15px;
      }
    }
    .list-item {
      height: 40px;
      align-items: center;
      box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.06);
      img {
        max-width: 16px;
        margin-right: 8px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: #14171c;
        line-height: 16px;
      }
    }
  }
  .isPc {
    display: none;
  }
}

@media (min-width: 1026px) {
  .isMobile {
    display: none;
  }
  .isPc {
    display: flex;
  }
}
</style>
